export default __webpack_public_path__ + "4287ff0d684d501854354165e62a0b29.png";